module.exports = __webpack_public_path__ + "static/bitcoincabana-icon-dd92b668a3c1b5b5d875ac622aeb8868.png";